module.exports = __webpack_public_path__ + "img/GY.24258db8.svg";